import {
  Snackbar,
  Alert,
  CircularProgress,
  Backdrop,
  Icon,
  Grid,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Divider,
  Tooltip,
  ListItem,
  ListItemIcon,
  ListItemText,
  Button,
  TextField,
  InputAdornment,
  TableRow,
  TableCell,
  Table,
  TableBody,
  Checkbox,
} from "@mui/material";

import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import axios from "axios.js";
import usePageTitle from "app/pageTitle";
import { ReactSortable } from "react-sortablejs";
import DataTable from "theme/Tables/DataTable";

function EditDataForm() {
  const title = "Edit Data Form";
  usePageTitle(title);

  const { id } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [refreshPage, setRefreshPage] = useState(false);

  const [dataForm, setDataForm] = useState(null);
  const [dataFields, setDataFields] = useState([]);
  const [dataFormName, setDataFormName] = useState(null);
  const [formSuccessMessage, setFormSuccessMessage] = useState(null);
  const [dataFormSections, setDataFormSections] = useState([]);

  const [openAddSectionDialog, setOpenAddSectionDialog] = useState(false);
  const [openEditSectionDialog, setOpenEditSectionDialog] = useState(false);
  const [openAddFieldDialog, setOpenAddFieldDialog] = useState(false);
  const [openEditFieldDialog, setOpenEditFieldDialog] = useState(false);
  const [dataFormSectionName, setDataFormSectionName] = useState(null);
  const [dataFormSectionDescription, setDataFormSectionDescription] = useState(null);

  const [formFieldType, setFormFieldType] = useState(null);
  const [formFieldDisplayName, setFormFieldDisplayName] = useState(null);
  const [formFieldKey, setFormFieldKey] = useState(null);
  const [formFieldOptions, setFormFieldOptions] = useState([]);
  const [formFieldValidationParams, setFormFieldValidationParams] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);
  const [selectedField, setSelectedField] = useState(null);
  const [formFieldEditable, setFormFieldEditable] = useState(false);
  const [formFieldOptional, setFormFieldOptional] = useState(false);

  const [selectedDataFormSection, setSelectedDataFormSection] = useState(null);
  const [selectedDataFormSectionFields, setSelectedDataFormSectionFields] = useState([]);
  const [selectedFormFieldOptions, setSelectedFormFieldOptions] = useState([]);
  const [selectedFormFieldParamsOptions, setSelectedFormFieldParamsOptions] = useState(null);

  const [validationParams, setValidationParams] = useState(null);
  const [showFieldOptions, setShowFieldOptions] = useState(false);
  const [isRelatedFields, setIsRelatedFields] = useState(false);
  // const [relatedChild, setRelatedChild] = useState(null);
  // const [relatedChildDisplayName, setRelatedChildDisplayName] = useState(null);
  // const [relatedChildCustomKey, setRelatedChildCustomKey] = useState(null);
  const [openAddRelatedOptionsDialog, setOpenAddRelatedOptionsDialog] = useState(false);
  const [relatedParentOption, setRelatedParentOption] = useState(null);
  const [relatedChildOptions, setRelatedChildOptions] = useState(null);
  const [relatedOptions, setRelatedOptions] = useState({});
  const [selectedRelatedOptionIndex, setSelectedRelatedOptionIndex] = useState(null);
  const [relatedParentField, setRelatedParentField] = useState(null);

  const [isFormula, setIsFormula] = useState(false);
  const [formula, setFormula] = useState(null);
  const [formulaParams, setFormulaParams] = useState([{}]);
  const addParam = () => {
    setFormulaParams([...formulaParams, {}]);
  };

  const [currentField, setCurrentField] = useState(null);
  const [fieldMeta, setFieldMeta] = useState(null);

  const [rules, setRules] = useState([]);
  const [formRules, setFormRules] = useState([]);
  const [selectedRule, setSelectedRule] = useState(null);
  const [selectedRuleFields, setSelectedRuleFields] = useState({});
  const [dataFormFields, setDataFormFields] = useState([]);
  const [openAddValidatorDialog, setOpenAddValidatorDialog] = useState(false);

  const [leadConnector, setLeadConnector] = useState(null);
  const [leadBuckets, setLeadBuckets] = useState([]);
  const [leadFields, setLeadFields] = useState({});
  const [selectedBucket, setSelectedBucket] = useState(null);
  const [openLinkBucketDialog, setOpenLinkBucketDialog] = useState(false);

  const [navigationLogics, setNavigationLogics] = useState([]);
  const [selectednavigationLogic, setSelectednavigationLogic] = useState(null);
  const [openNavigationLogicDialog, setOpenNavigationLogicDialog] = useState(false);
  const [navigationLogicFields, setNavigationLogicFields] = useState([]);
  const [selectedNavigationLogicField, setSelectedNavigationLogicField] = useState(null);
  const [selectedNavigationLogicFieldDisplayType, setSelectedNavigationLogicFieldDisplayType] =
    useState(null);
  const [selectedNavigationLogicFieldControlValue, setSelectedNavigationLogicFieldControlValue] =
    useState(null);
  const [selectedNavigationLogicFieldDependant, setSelectedNavigationLogicFieldDependant] =
    useState(null);
  const [openNewNavigationLogicDialog, setOpenNewNavigationLogicDialog] = useState(false);

  async function removeValidator(ref) {
    setShowLoading(true);
    await axios
      .get(`portal/data_forms/validators/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const formRulesTableColumns = [
    { Header: "Rule", accessor: "title", align: "left" },
    { Header: "Fields", accessor: "fields", align: "left" },
    { Header: "Cost", accessor: "cost", align: "left" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildFormRulesRows = (data) => {
    const rows = [];
    data.map((rule) => {
      rows.push({
        title: rule.title,
        fields: rule.fields,
        cost: rule.cost > 0 ? `${rule.currency}${(rule.cost / 100).toFixed(2)}` : `FREE TO USE`,
        actions: (
          <MDButton
            size="small"
            variant="outlined"
            color="error"
            iconOnly
            onClick={() => {
              if (window.confirm(`Delete this validator?`) === true) {
                removeValidator(rule.reference);
              }
            }}
          >
            <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
              delete
            </Icon>
          </MDButton>
        ),
      });
      return null;
    });

    return rows;
  };

  const navigationLogicTableColumns = [
    { Header: "Control Field", accessor: "field", align: "left" },
    { Header: "Section", accessor: "section", align: "left" },
    { Header: "Display Type", accessor: "type", align: "left" },
    // { Header: "Dependants", accessor: "dependants", align: "left" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildNavigationLogicRows = (data) => {
    const rows = [];
    data.map((logic) => {
      rows.push({
        field: logic.field,
        section: logic.section,
        type: logic.type,
        actions: (
          <MDBox display="flex" justifyContent="space-between">
            <MDButton
              size="small"
              variant="outlined"
              color="info"
              iconOnly
              onClick={() => {
                setSelectednavigationLogic(logic);
                setOpenNavigationLogicDialog(true);
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small">
                visibility
              </Icon>
            </MDButton>
            &nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Remove this entry?`) === true) {
                  deleteNavigationLogic(logic.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`portal/data_forms/${id}/fetch.json`)
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            // console.log(result.data.data);
            setDataFields(result.data.data.data_fields);
            setDataFormSections(result.data.data.data_form.form.sections);
            setDataFormName(result.data.data.data_form.title);
            setFormSuccessMessage(result.data.data.data_form.success_message);
            setDataForm(result.data.data.data_form);
            // console.log(result.data.data.data_form);
            if (selectedDataFormSection !== null) {
              result.data.data.data_form.form.sections.every((sect) => {
                if (sect.reference === selectedDataFormSection.reference) {
                  setSelectedDataFormSection(sect);
                  return false;
                }
                return true;
              });
            }

            setRules(result.data.data.rules);
            const rows = buildFormRulesRows(result.data.data.data_form_rules);
            setFormRules(rows);

            const rowsLogics = buildNavigationLogicRows(result.data.data.logics);
            setNavigationLogics(rowsLogics);
            setNavigationLogicFields(result.data.data.logic_fields);

            const dfs = [];
            result.data.data.data_form.form.sections.forEach((sec) => {
              sec.fields.every((f) => {
                // if (!f.has_parent) {
                //   dfs.push(f);
                // }
                dfs.push(f);
                return true;
              });
            });
            setDataFormFields(dfs);

            setLeadBuckets(result.data.data.buckets);
            setLeadConnector(result.data.data.lead_connector);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  useEffect(() => {
    if (selectedDataFormSection === null) {
      setSelectedDataFormSectionFields([]);
      return;
    }
    const tmp = [];
    selectedDataFormSection.fields.every((f) => {
      tmp.push(f);
      return true;
    });
    setSelectedDataFormSectionFields(tmp);
  }, [selectedDataFormSection]);

  async function editFormName() {
    if (dataFormName === null) {
      setErrMsg("Form name is required");
      setSeverity("error");
      setOpen(true);
      return;
    }

    setShowLoading(true);
    const json = {
      title: dataFormName,
      success_message: formSuccessMessage,
      reference: id,
    };
    await axios
      .post(`portal/data_forms/modify.json`, json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function editSection() {
    if (dataFormSectionName === null) {
      setErrMsg("Section name is required");
      setSeverity("error");
      setOpen(true);
      return;
    }

    if (dataFormSectionDescription === null) {
      setErrMsg("Section description is required");
      setSeverity("error");
      setOpen(true);
      return;
    }

    setOpenEditSectionDialog(false);
    setShowLoading(true);
    const json = {
      title: dataFormSectionName,
      description: dataFormSectionDescription,
      reference: selectedSection.reference,
    };
    // console.log(json);

    await axios
      .post(`portal/data_forms/sections/edit.json`, json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function addSection() {
    if (dataFormSectionName === null) {
      setErrMsg("Section name is required");
      setSeverity("error");
      setOpen(true);
      return;
    }

    if (dataFormSectionDescription === null) {
      setErrMsg("Section description is required");
      setSeverity("error");
      setOpen(true);
      return;
    }

    setOpenAddSectionDialog(false);
    setShowLoading(true);
    const json = {
      title: dataFormSectionName,
      description: dataFormSectionDescription,
      fields: [],
      form: id,
    };
    // console.log(json);

    await axios
      .post("portal/data_forms/sections/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function reOrderSections() {
    const positions = [];
    dataFormSections.every((section, index) => {
      positions.push({
        reference: section.reference,
        position: index,
      });
      return true;
    });

    setShowLoading(true);
    const json = {
      sections: positions,
      form: id,
    };

    await axios
      .post("portal/data_forms/sections/re_order.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function addField() {
    if (formFieldType === null) {
      setErrMsg("Field type is required");
      setSeverity("error");
      setOpen(true);
      return;
    }

    if (formFieldDisplayName === null) {
      setErrMsg("Field display name is required");
      setSeverity("error");
      setOpen(true);
      return;
    }

    // let fieldName = "";
    // dataFields.every((param) => {
    //   if (param.reference === formFieldType) {
    //     fieldName = param.name;
    //   }
    //   return true;
    // });

    // console.log(relatedOptions);

    let metaData = fieldMeta;
    if (isRelatedFields) {
      if (relatedOptions === null) {
        setErrMsg("Related options are required");
        setSeverity("error");
        setOpen(true);
        return;
      }

      metaData = {
        related_options: relatedOptions,
      };
    }

    if (currentField.field_type === "calculated_value") {
      if (metaData === null) {
        setErrMsg("Calculated value is not complete.");
        setSeverity("error");
        setOpen(true);
        return;
      }

      if (metaData.operator === null || metaData.operator.length <= 0) {
        setErrMsg("Select a calculation type.");
        setSeverity("error");
        setOpen(true);
        return;
      }

      if (metaData.fields.first.name === null || metaData.fields.first.name <= 0) {
        setErrMsg("First field display name required.");
        setSeverity("error");
        setOpen(true);
        return;
      }

      if (metaData.fields.second.name === null || metaData.fields.second.name <= 0) {
        setErrMsg("Second field display name required.");
        setSeverity("error");
        setOpen(true);
        return;
      }
    }

    if (currentField.field_type === "formula_field") {
      // console.log(fieldMeta);
      if (fieldMeta === null) {
        setErrMsg("Formula is required.");
        setSeverity("error");
        setOpen(true);
        return;
      }

      if (fieldMeta.formula === null) {
        setErrMsg("Formula is required.");
        setSeverity("error");
        setOpen(true);
        return;
      }

      const regex2 = /[+-/*()]/;
      if (!regex2.test(fieldMeta.formula)) {
        setErrMsg("Formula must contain an operator.");
        setSeverity("error");
        setOpen(true);
        return;
      }

      if (formulaParams.length < 1) {
        setErrMsg("Too few formula parameters.");
        setSeverity("error");
        setOpen(true);
        return;
      }

      let error = "";
      let errorCount = 0;
      formulaParams.every((r) => {
        if (typeof r.field === "undefined" || r.field === null) {
          error = `All parameter fields are required`;
          errorCount += 1;
          return false;
        }
        return true;
      });

      if (errorCount > 0) {
        setErrMsg(error);
        setSeverity("error");
        setOpen(true);
        return;
      }

      metaData = {
        formula_field: {
          formula: fieldMeta.formula,
          parameters: formulaParams,
        },
      };
    }

    const json = {
      section: selectedSection.reference,
      // field_name: fieldName,
      field_type: formFieldType,
      display_name: formFieldDisplayName,
      custom_key: formFieldKey,
      options: formFieldOptions,
      validation_params: formFieldValidationParams,
      meta: metaData,
      editable: formFieldEditable,
      optional: formFieldOptional,
      parent: relatedParentField,
    };
    // console.log(json);

    setOpenAddFieldDialog(false);
    setSelectedSection(null);
    setShowLoading(true);
    await axios
      .post(`/portal/data_forms/fields/create.json`, json)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function editField() {
    if (formFieldDisplayName === null) {
      setErrMsg("Field display name is required");
      setSeverity("error");
      setOpen(true);
      return;
    }

    let metaData = null;
    if (isRelatedFields) {
      // console.log(relatedOptions);
      if (relatedOptions === null) {
        setErrMsg("Related options are required");
        setSeverity("error");
        setOpen(true);
        return;
      }
      metaData = {
        related_options: relatedOptions,
      };
    }

    if (isFormula) {
      if (formula === null) {
        setErrMsg("Formula is required.");
        setSeverity("error");
        setOpen(true);
        return;
      }

      const regex2 = /[+-/*()]/;
      if (!regex2.test(formula)) {
        setErrMsg("Formula must contain an operator.");
        setSeverity("error");
        setOpen(true);
        return;
      }

      if (formulaParams.length < 1) {
        setErrMsg("Too few formula parameters.");
        setSeverity("error");
        setOpen(true);
        return;
      }

      let error = "";
      let errorCount = 0;
      formulaParams.every((r) => {
        if (typeof r.field === "undefined" || r.field === null) {
          error = `All parameter fields are required`;
          errorCount += 1;
          return false;
        }
        return true;
      });

      if (errorCount > 0) {
        setErrMsg(error);
        setSeverity("error");
        setOpen(true);
        return;
      }

      metaData = {
        formula_field: {
          formula: `${formula}`,
          parameters: formulaParams,
        },
      };
    }

    // if (1 === 1) {
    //   return;
    // }

    const json = {
      reference: selectedField.reference,
      field_type: formFieldType,
      display_name: formFieldDisplayName,
      custom_key: formFieldKey,
      options: selectedFormFieldOptions,
      validation_params: formFieldValidationParams,
      meta: metaData,
      editable: formFieldEditable,
      optional: formFieldOptional,
      parent: relatedParentField,
    };

    // console.log(json);

    setOpenEditFieldDialog(false);
    setSelectedField(null);
    setShowLoading(true);
    await axios
      .post(`/portal/data_forms/fields/edit.json`, json)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function removeSection(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/data_forms/sections/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function removeField(ref) {
    setShowLoading(true);
    await axios
      .get(`/portal/data_forms/fields/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  useEffect(() => {
    setFormFieldOptions([]);
    setFormFieldValidationParams(null);
    setFieldMeta(null);
    // setFormFieldEditable(false);

    dataFields.every((param) => {
      if (param.reference === formFieldType) {
        if (param.validation_params.length > 0) {
          setValidationParams(param.validation_params);
        } else {
          setValidationParams(null);
        }

        if (param.options_reqd) {
          setShowFieldOptions(true);
        } else {
          setShowFieldOptions(false);
        }

        if (param.related_field) {
          setIsRelatedFields(true);
        } else {
          setIsRelatedFields(false);
        }

        if (param.field_type === "formula_field") {
          setIsFormula(true);
        } else {
          setIsFormula(false);
        }

        setCurrentField(param);
        return false;
      }
      return true;
    });
  }, [formFieldType]);

  function sectionHighlight(section) {
    if (selectedDataFormSection === null) {
      return "outlined";
    }
    if (section.reference === selectedDataFormSection.reference) {
      return "contained";
    }

    return "outlined";
  }

  async function reOrderSectionFields() {
    const positions = [];
    selectedDataFormSectionFields.every((field, index) => {
      positions.push({
        reference: field.reference,
        position: index,
      });
      return true;
    });

    setShowLoading(true);
    const json = {
      fields: positions,
      section: selectedDataFormSection.reference,
      form: id,
    };

    await axios
      .post("portal/data_forms/sections/fields/re_order.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          // setSelectedDataFormSection(null);
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function readOptionsCSV(file) {
    const reader = new FileReader();

    return new Promise((resolve, reject) => {
      reader.onload = function (event) {
        const csv = event.target.result;
        const lines = csv.trim().split("\n");
        // const headers = lines[0].split(",");
        // if (!headers.includes("name") || !headers.includes("value")) {
        //   reject(new Error("Name or value column missing."));
        //   resolve(false);
        // }

        let string = "";

        /* eslint-disable no-restricted-syntax, no-continue, prefer-destructuring */
        let i = 0;
        for (const line of lines) {
          if (line === undefined || line.trim().length === 0) {
            continue;
          }

          if (i === 0) {
            i += 1;
            continue;
          }

          let name = "";
          let value = "";
          const values = line.split(",");
          if (values.length > 1) {
            if (values[0].trim().length === 0) {
              continue;
            }
            name = values[0];
            if (values[1].trim().length === 0) {
              value = values[0];
            } else {
              value = values[1];
            }
          } else {
            name = line;
            value = line;
          }

          string += `${name}:${value},\n`;
          i += 1;
        }
        resolve(string);
      };

      reader.onerror = function () {
        reject(new Error("Error reading file"));
        resolve(false);
      };

      reader.readAsText(file);
    });
  }

  function buildRelatedOptionsTable() {
    const items = [];
    Object.keys(relatedOptions).forEach((key) => {
      items.push(
        <TableRow>
          <TableCell>
            <MDTypography variant="subtitle2" fontSize={14}>
              {key}
            </MDTypography>
            <MDTypography variant="subtitle2" fontSize={10}>
              <Tooltip title="Edit">
                <MDButton
                  size="small"
                  iconOnly
                  onClick={() => {
                    setRelatedParentOption(key);
                    setRelatedChildOptions(relatedOptions[key]);
                    setSelectedRelatedOptionIndex(key);
                    setOpenAddRelatedOptionsDialog(true);
                  }}
                >
                  <Icon color="warning">edit</Icon>
                </MDButton>
              </Tooltip>
              &nbsp;&nbsp;
              <Tooltip title="Delete">
                <MDButton
                  size="small"
                  iconOnly
                  onClick={() => {
                    if (window.confirm("Delete?") === true) {
                      const tmp = relatedOptions;
                      delete tmp[key];
                      setRelatedOptions(tmp);

                      setSeverity("warning");
                      setErrMsg("Related option deleted.");
                      setOpen(true);
                    }
                  }}
                >
                  <Icon color="error">delete</Icon>
                </MDButton>
              </Tooltip>
            </MDTypography>
          </TableCell>
          <TableCell>
            <MDTypography variant="subtitle2" fontSize={12}>
              {relatedOptions[key]}
            </MDTypography>
          </TableCell>
        </TableRow>
      );
    });
    return items;
  }

  useEffect(() => {
    setSelectedRuleFields({});
  }, [selectedRule]);

  async function createValidationRule() {
    if (selectedRule === null) {
      setSeverity("error");
      setErrMsg("Please select a validation rule.");
      setOpen(true);
      return;
    }

    let errors = false;
    if (selectedRule.parameters.length > 0) {
      selectedRule.parameters.forEach((p) => {
        if (!selectedRuleFields[p.key]) {
          setSeverity("error");
          setErrMsg(`${p.display_name} is required.`);
          setOpen(true);
          errors = true;
        }
      });
    }

    if (errors) {
      return;
    }

    setOpenAddValidatorDialog(false);
    setShowLoading(true);

    const json = {
      form: id,
      reference: selectedRule.reference,
      fields: selectedRuleFields,
    };

    console.log(json);

    await axios
      .post("portal/data_forms/validators/attach.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  // useEffect(() => {
  //   if (selectedBucket === null) {
  //     setSelectedDataFormSectionFields([]);
  //     return;
  //   }
  // }, [selectedBucket]);

  function buildLeadAttributeRows() {
    const fields = [];
    Object.keys(selectedBucket.fields).forEach((code) => {
      fields.push(
        <MDBox mb={3}>
          <MDBox display="flex" justifyContent="space-between">
            <MDBox>
              <MDTypography variant="h6" fontSize={14} fontWeight="light">
                <b>{selectedBucket.fields[code]}</b>
                <br />(
                {["lead_email_address", "lead_phone_number"].includes(code)
                  ? "Optional"
                  : "Required"}
                )
              </MDTypography>
            </MDBox>
            <MDBox>
              <MDTypography variant="h6" fontSize={14} mt={2}>
                <Icon variant="outlined">east</Icon>
              </MDTypography>
            </MDBox>
            <MDBox mt={0.5}>
              <FormControl sx={{ minWidth: 130, width: "100%" }}>
                <InputLabel>Select Field</InputLabel>
                <Select
                  label="Select Field"
                  onChange={(e) => {
                    const temp = leadFields;
                    leadFields[code] = e.target.value;
                    setLeadFields(temp);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {
                    // --> Notice below changes
                    dataFormFields.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      dataFormFields.map((record) => (
                        <MenuItem value={`${record.reference}`}>{record.display_name}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
          </MDBox>
        </MDBox>
      );
    });
    return fields;
  }

  async function connectLeadBucket() {
    if (selectedBucket === null) {
      setSeverity("error");
      setErrMsg("Please select a lead bucket.");
      setOpen(true);
      return;
    }

    if (leadFields.length < 0) {
      setSeverity("error");
      setErrMsg("Please map lead attributes to your form fields.");
      setOpen(true);
      return;
    }

    let errors = 0;
    Object.keys(selectedBucket.fields).forEach((code) => {
      if (
        (typeof leadFields[code] === "undefined" || leadFields[code] === null) &&
        !["lead_phone_number", "lead_email_address"].includes(code)
      ) {
        setSeverity("error");
        setErrMsg("Map all required attributes.");
        setOpen(true);
        errors += 1;
      }
    });

    if (errors > 0) {
      return;
    }

    if (
      (typeof leadFields.lead_phone_number === "undefined" ||
        leadFields.lead_phone_number === null) &&
      (typeof leadFields.lead_email_address === "undefined" ||
        leadFields.lead_email_address === null)
    ) {
      setSeverity("error");
      setErrMsg("Email address or Phone number is required");
      setOpen(true);
      return;
    }

    setOpenLinkBucketDialog(false);
    setShowLoading(true);

    const json = {
      form: id,
      bucket: selectedBucket.reference,
      fields: leadFields,
    };

    await axios
      .post("portal/data_forms/leads/connect.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteBucket(ref) {
    setOpenLinkBucketDialog(false);
    setShowLoading(true);
    await axios
      .get(`/portal/data_forms/leads/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function createNavigationLogic() {
    if (selectedNavigationLogicField === null) {
      setSeverity("error");
      setErrMsg("A control field is required");
      setOpen(true);
      return;
    }

    if (selectedNavigationLogicFieldControlValue === null) {
      setSeverity("error");
      setErrMsg("Please select control field's value.");
      setOpen(true);
      return;
    }

    if (selectedNavigationLogicFieldDisplayType === null) {
      setSeverity("error");
      setErrMsg("Please select a display type.");
      setOpen(true);
      return;
    }

    if (selectedNavigationLogicFieldDependant === null) {
      setSeverity("error");
      setErrMsg(
        selectedNavigationLogicFieldDisplayType === "SECTION"
          ? "Please select a section."
          : "Please select a form field."
      );
      setOpen(true);
      return;
    }

    setOpenNewNavigationLogicDialog(false);
    setShowLoading(true);

    const json = {
      reference: id,
      logic: {
        field: selectedNavigationLogicField.reference,
        type: selectedNavigationLogicFieldDisplayType,
        control: selectedNavigationLogicFieldControlValue,
        dependant: selectedNavigationLogicFieldDependant,
      },
    };

    await axios
      .post("portal/data_forms/navigation_logic/create.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteNavigationLogic(ref) {
    setOpenLinkBucketDialog(false);
    setShowLoading(true);
    await axios
      .get(`/portal/data_forms/navigation_logic/${ref}/delete.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {selectednavigationLogic && (
        <Dialog open={openNavigationLogicDialog} fullWidth>
          <DialogTitle>
            <MDBox align="center">
              <Icon>alt_route</Icon>
              <MDTypography variant="h6" fontWeight="regular" align="center">
                <strong>{selectednavigationLogic.type}</strong> Workflow
              </MDTypography>
            </MDBox>
          </DialogTitle>
          <Divider />
          <DialogContent>
            <MDBox>
              <MDBox mb={2}>
                <MDBox mb={2}>
                  <Grid container spacing={3}>
                    <Grid item xs={4} md={4} lg={4} align="center">
                      <MDTypography variant="subtitle2" fontWeight="light" align="left">
                        CONTROL FIELD
                      </MDTypography>
                    </Grid>
                    <Grid item xs={4} md={4} lg={4}>
                      <MDTypography variant="subtitle2" fontWeight="light" align="center">
                        SELECTED VALUE
                      </MDTypography>
                    </Grid>
                    <Grid item xs={4} md={4} lg={4}>
                      <MDTypography variant="subtitle2" fontWeight="light" align="right">
                        DISPLAY
                      </MDTypography>
                    </Grid>
                  </Grid>
                </MDBox>
              </MDBox>
              <MDBox mt={3}>
                <Grid container spacing={5}>
                  <Grid item xs={3} md={3} lg={3}>
                    <MDBox display="flex" alignItems="center" verticalAlign="center">
                      <MDBox>
                        <MDTypography variant="h6" fontWeight="regular">
                          {selectednavigationLogic.field}
                        </MDTypography>
                        <MDTypography variant="h6" fontWeight="light">
                          <small>{selectednavigationLogic.section}</small>
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </Grid>
                  <Grid item xs={9} md={9} lg={9}>
                    <MDBox>
                      {selectednavigationLogic.dependants.map((dep) => (
                        <MDBox mb={2}>
                          <Grid container spacing={3}>
                            <Grid item xs={3} md={3} lg={3}>
                              <Icon>east</Icon>
                            </Grid>
                            <Grid item xs={3} md={3} lg={3}>
                              <MDTypography variant="h6" fontWeight="light">
                                {dep.control}
                              </MDTypography>
                            </Grid>
                            <Grid item xs={3} md={3} lg={3}>
                              <Icon>
                                {selectednavigationLogic.type === "SECTION" ? "east" : "hdr_strong"}
                              </Icon>
                            </Grid>
                            <Grid item xs={3} md={3} lg={3}>
                              <MDTypography variant="h6" fontWeight="regular" align="right">
                                {dep.dependant}
                              </MDTypography>
                            </Grid>
                          </Grid>
                        </MDBox>
                      ))}
                    </MDBox>
                  </Grid>
                </Grid>
              </MDBox>
            </MDBox>
          </DialogContent>
          <DialogActions>
            <MDButton
              onClick={() => {
                setOpenNavigationLogicDialog(false);
              }}
              color="dark"
              variant="outlined"
              iconOnly
              circular
            >
              <Icon>close</Icon>
            </MDButton>
          </DialogActions>
        </Dialog>
      )}

      <Dialog open={openNewNavigationLogicDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDTypography variant="h6" fontWeight="regular">
            New Dynamic Flow
          </MDTypography>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <MDBox mt={2}>
              <FormControl sx={{ minWidth: 130, width: "100%" }}>
                <InputLabel>Control Field</InputLabel>
                <Select
                  label="Control Field"
                  onChange={(e) => {
                    let f = null;
                    navigationLogicFields.every((fld) => {
                      if (fld.reference === e.target.value) {
                        setSelectedNavigationLogicField(fld);
                        return false;
                      }
                      return true;
                    });
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {
                    // --> Notice below changes
                    navigationLogicFields.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      navigationLogicFields.map((record) => (
                        <MenuItem value={`${record.reference}`}>{record.display_name}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
            {selectedNavigationLogicField && (
              <>
                <MDBox mt={4}>
                  <FormControl sx={{ minWidth: 130, width: "100%" }}>
                    <InputLabel>Control Value</InputLabel>
                    <Select
                      label="Control Value"
                      onChange={(e) => {
                        setSelectedNavigationLogicFieldControlValue(e.target.value);
                      }}
                      sx={{ padding: "12px", paddingLeft: "3px" }}
                    >
                      {
                        // --> Notice below changes
                        selectedNavigationLogicField.options.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                          selectedNavigationLogicField.options.map((record) => (
                            <MenuItem value={`${record.value}`}>{record.name}</MenuItem>
                          ))
                      }
                    </Select>
                  </FormControl>
                </MDBox>
                <MDBox mt={3} align="center">
                  <Icon>south</Icon>
                </MDBox>
                <MDBox mt={3}>
                  <FormControl sx={{ minWidth: 130, width: "100%" }}>
                    <InputLabel>Display Type</InputLabel>
                    <Select
                      label="Display Type"
                      onChange={(e) => {
                        setSelectedNavigationLogicFieldDisplayType(e.target.value);
                      }}
                      sx={{ padding: "12px", paddingLeft: "3px" }}
                    >
                      <MenuItem value="FIELD">Form Field</MenuItem>
                      <MenuItem value="SECTION">Form Section</MenuItem>
                    </Select>
                  </FormControl>
                </MDBox>
                {selectedNavigationLogicFieldControlValue &&
                  selectedNavigationLogicFieldDisplayType && (
                    <MDBox mt={5}>
                      <MDBox mt={3}>
                        {selectedNavigationLogicFieldDisplayType === "FIELD" ? (
                          <FormControl sx={{ minWidth: 120, width: "100%" }}>
                            <InputLabel>Form Field</InputLabel>
                            <Select
                              label="Form Field"
                              onChange={(e) => {
                                setSelectedNavigationLogicFieldDependant(e.target.value);
                              }}
                              sx={{ padding: "12px", paddingLeft: "3px" }}
                            >
                              {
                                // --> Notice below changes
                                dataFormFields.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                  dataFormFields.map((record) => {
                                    if (
                                      record.reference !== selectedNavigationLogicField.reference
                                    ) {
                                      return (
                                        <MenuItem value={`${record.reference}`}>
                                          {record.display_name}
                                        </MenuItem>
                                      );
                                    }
                                    return null;
                                  })
                              }
                            </Select>
                          </FormControl>
                        ) : (
                          <FormControl sx={{ minWidth: 120, width: "100%" }}>
                            <InputLabel>Form Section</InputLabel>
                            <Select
                              label="Form Section"
                              onChange={(e) => {
                                setSelectedNavigationLogicFieldDependant(e.target.value);
                              }}
                              sx={{ padding: "12px", paddingLeft: "3px" }}
                            >
                              {
                                // --> Notice below changes
                                dataFormSections.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                  dataFormSections.map((record) => {
                                    if (
                                      record.reference !==
                                      selectedNavigationLogicField.section.reference
                                    ) {
                                      return (
                                        <MenuItem value={`${record.reference}`}>
                                          {record.title}
                                        </MenuItem>
                                      );
                                    }
                                    return null;
                                  })
                              }
                            </Select>
                          </FormControl>
                        )}
                      </MDBox>
                    </MDBox>
                  )}
              </>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenNewNavigationLogicDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              createNavigationLogic();
            }}
          >
            Save
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog open={openLinkBucketDialog} fullWidth maxWidth={leadConnector ? "xs" : "sm"}>
        <DialogTitle>
          <MDBox>Lead Connector</MDBox>
        </DialogTitle>
        <DialogContent>
          {leadConnector !== null ? (
            <MDBox px={1} mb={3}>
              <MDBox display="flex" justifyContent="space-between">
                <MDBox>
                  <MDTypography variant="h6" fontSize={12} fontWeight="light">
                    Lead Bucket
                  </MDTypography>
                  <MDTypography variant="h6" fontSize={16} fontWeight="regular">
                    {leadConnector.bucket}
                  </MDTypography>
                </MDBox>
                <MDBox>
                  <MDButton
                    variant="outlined"
                    color="error"
                    iconOnly
                    size="small"
                    onClick={() => {
                      if (window.confirm("Delete connected lead bucket?") === true) {
                        deleteBucket(leadConnector.reference);
                      }
                    }}
                  >
                    <Icon>delete</Icon>
                  </MDButton>
                </MDBox>
              </MDBox>
            </MDBox>
          ) : (
            <MDBox px={1} mb={5}>
              <MDBox>
                <Alert severity="info">
                  Automate lead generation using data forms. Connect lead buckets to data forms.
                </Alert>
              </MDBox>
              <MDBox mt={5}>
                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                  <InputLabel>Select Lead Bucket</InputLabel>
                  <Select
                    label="Select Lead Bucket"
                    onChange={(e) => {
                      leadBuckets.forEach((bucket) => {
                        if (bucket.reference === e.target.value) {
                          setSelectedBucket(bucket);
                        }
                      });
                    }}
                    sx={{ padding: "12px", paddingLeft: "3px" }}
                  >
                    {
                      // --> Notice below changes
                      leadBuckets.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                        leadBuckets.map((record) => (
                          <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                        ))
                    }
                  </Select>
                </FormControl>
              </MDBox>
              <MDBox>
                {selectedBucket !== null && (
                  <MDBox mt={4}>
                    <MDTypography
                      pl={0}
                      mb={2}
                      variant="h6"
                      fontSize={16}
                      fontWeight="regular"
                      align="center"
                    >
                      Map lead attributes to form fields.
                    </MDTypography>
                    <MDBox>
                      <Divider />
                    </MDBox>
                    <MDBox display="flex" justifyContent="space-between">
                      <MDBox>
                        <MDTypography variant="h6" fontSize={14} fontWeight="regular">
                          Lead Attribute
                        </MDTypography>
                      </MDBox>
                      <MDBox pr={1}>
                        <MDTypography variant="h6" fontSize={14} fontWeight="regular">
                          Form Field
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                    <MDBox>
                      <Divider />
                    </MDBox>
                    <MDBox>{buildLeadAttributeRows().map((row) => row)}</MDBox>
                  </MDBox>
                )}
              </MDBox>
            </MDBox>
          )}
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenLinkBucketDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          {!leadConnector && (
            <MDButton
              color="info"
              variant="outlined"
              onClick={() => {
                connectLeadBucket();
              }}
              startIcon={<Icon>electrical_services</Icon>}
            >
              Connect
            </MDButton>
          )}
        </DialogActions>
      </Dialog>
      <Dialog open={openAddValidatorDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Add Validation Rule</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox px={0} mb={5}>
            <MDBox mt={1}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Validation Rule</InputLabel>
                <Select
                  label="Validation Rule"
                  onChange={(e) => {
                    rules.forEach((rule) => {
                      if (rule.reference === e.target.value) {
                        setSelectedRule(rule);
                      }
                    });
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {
                    // --> Notice below changes
                    rules.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      rules.map((record) => (
                        <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
            <MDBox>
              {selectedRule !== null && (
                <MDBox mt={2}>
                  <MDBox px={0.1}>
                    <Alert severity="info">
                      <MDTypography variant="subtitle2" fontSize={14}>
                        {selectedRule.description}
                      </MDTypography>
                      <MDTypography mt={1} variant="h6" fontSize={12} fontWeight="regular">
                        Cost:{" "}
                        {selectedRule.cost > 0
                          ? `${selectedRule.currency}${(selectedRule.cost / 100).toFixed(2)}`
                          : `FREE TO USE`}
                      </MDTypography>
                    </Alert>
                  </MDBox>
                  {selectedRule.parameters.length > 0 && (
                    <MDBox mt={3}>
                      <MDTypography pl={1} mb={2} variant="h6" fontSize={14} fontWeight="regular">
                        Map form fields to be validated
                      </MDTypography>
                      {selectedRule.parameters.map((param) => (
                        <MDBox mb={3}>
                          <FormControl sx={{ minWidth: 120, width: "100%" }}>
                            <InputLabel>{param.display_name}</InputLabel>
                            <Select
                              label={param.display_name}
                              onChange={(e) => {
                                const temp = selectedRuleFields;
                                temp[param.key] = e.target.value;
                                setSelectedRuleFields(temp);
                              }}
                              sx={{ padding: "12px", paddingLeft: "3px" }}
                            >
                              {
                                // --> Notice below changes
                                dataFormFields.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                  dataFormFields.map((record) => (
                                    <MenuItem value={`${record.reference}`}>
                                      {record.display_name}
                                    </MenuItem>
                                  ))
                              }
                            </Select>
                          </FormControl>
                        </MDBox>
                      ))}
                    </MDBox>
                  )}
                </MDBox>
              )}
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAddValidatorDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              createValidationRule();
            }}
          >
            Add Rule
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openAddSectionDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Add Section</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={2}>
              <MDInput
                name="name"
                margin="dense"
                label="Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setDataFormSectionName(e.target.value)}
              />
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                multiline
                rows={3}
                name="description"
                margin="dense"
                label="Description"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setDataFormSectionDescription(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAddSectionDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              addSection();
            }}
          >
            Add Section
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openEditSectionDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Edit Section</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={2}>
              <MDInput
                value={dataFormSectionName}
                name="name"
                margin="dense"
                label="Name"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setDataFormSectionName(e.target.value)}
              />
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                value={dataFormSectionDescription}
                multiline
                rows={3}
                name="description"
                margin="dense"
                label="Description"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setDataFormSectionDescription(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenEditSectionDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              editSection();
            }}
          >
            Save Changes
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openAddFieldDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <MDBox>Add Field</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox mt={2}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Field Type</InputLabel>
                <Select
                  label="Field Type"
                  onChange={(e) => {
                    setFormFieldValidationParams(null);
                    setFormFieldOptions([]);
                    setFormFieldType(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {
                    // --> Notice below changes
                    dataFields.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      dataFields.map((record) => (
                        <MenuItem value={`${record.reference}`}>{record.name}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
            {formFieldType && (
              <MDBox>
                {!isRelatedFields ? (
                  <MDBox>
                    {currentField && currentField.field_type !== "calculated_value" && (
                      <MDBox>
                        <MDBox mt={4}>
                          <MDInput
                            name="name"
                            margin="dense"
                            label="Display Name"
                            type="text"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => setFormFieldDisplayName(e.target.value)}
                          />
                        </MDBox>
                        <MDBox mt={2}>
                          <MDInput
                            name="custom_key"
                            margin="dense"
                            label="Custom Key (Optional)"
                            type="text"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => setFormFieldKey(e.target.value)}
                          />
                        </MDBox>
                        <MDBox mt={2} display="flex" alignItems="center" ml={-1}>
                          <Checkbox
                            checked={formFieldOptional}
                            onChange={(e) => {
                              setFormFieldOptional(e.target.checked);
                            }}
                            inputProps={{ "aria-label": "controlled" }}
                          />
                          <MDTypography
                            variant="button"
                            fontWeight="regular"
                            color="text"
                            sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                          >
                            &nbsp;&nbsp;Make optional?
                          </MDTypography>
                        </MDBox>
                        {validationParams && (
                          <MDBox mt={2}>
                            <MDBox p={1}>
                              <MDTypography variant="h6" fontWeight="medium">
                                Validation Options
                              </MDTypography>
                            </MDBox>
                            {
                              // --> Notice below changes
                              validationParams.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                validationParams.map((record) => {
                                  if (record.options) {
                                    return (
                                      <MDBox mt={3} mb={2}>
                                        <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                          <InputLabel>{record.name}</InputLabel>
                                          <Select
                                            label={record.name}
                                            onChange={(e) => {
                                              let params = formFieldValidationParams;
                                              if (params === null) {
                                                params = {};
                                              }
                                              params[record.key] = e.target.value;
                                              setFormFieldValidationParams(params);
                                            }}
                                            sx={{ padding: "12px", paddingLeft: "3px" }}
                                          >
                                            {
                                              // --> Notice below changes
                                              record.options.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                                record.options.map((opt) => (
                                                  <MenuItem value={`${opt.value}`}>
                                                    {opt.name}
                                                  </MenuItem>
                                                ))
                                            }
                                          </Select>
                                        </FormControl>
                                      </MDBox>
                                    );
                                  }

                                  return (
                                    <MDBox mb={2}>
                                      <MDInput
                                        name="custom_key"
                                        margin="dense"
                                        label={record.name}
                                        type="text"
                                        fullWidth
                                        variant="outlined"
                                        onChange={(e) => {
                                          let params = formFieldValidationParams;
                                          if (params === null) {
                                            params = {};
                                          }
                                          params[record.key] = e.target.value;
                                          setFormFieldValidationParams(params);
                                        }}
                                      />
                                    </MDBox>
                                  );
                                })
                            }
                          </MDBox>
                        )}
                        {showFieldOptions && (
                          <MDBox mt={2}>
                            <MDInput
                              multiline
                              rows={3}
                              name="form_options"
                              margin="dense"
                              label="Field Options"
                              placeholder="Comma separated name:value pairs."
                              type="text"
                              fullWidth
                              variant="outlined"
                              value={formFieldOptions}
                              onChange={(e) => setFormFieldOptions(e.target.value)}
                            />
                            <MDBox pl={1}>
                              <small>Ex: Male:M, Female:F, Mercedes:benz, Vehicle Type:SUV</small>
                            </MDBox>

                            <MDBox mt={2}>
                              <MDTypography variant="h6" fontWeight="light" fontSize={13} pl={0.5}>
                                Upload CSV file
                              </MDTypography>
                              <TextField
                                type="file"
                                size="small"
                                placeholder="Upload csv options."
                                onChange={async (e) => {
                                  const file = e.target.files[0];
                                  try {
                                    const string = await readOptionsCSV(file);
                                    setFormFieldOptions(string);
                                  } catch (error) {
                                    console.error(error);
                                  }
                                }}
                                startAdornment={
                                  <InputAdornment position="start">
                                    <Icon color="info">file</Icon>
                                  </InputAdornment>
                                }
                                fullWidth
                              />
                              <MDTypography
                                variant="h6"
                                fontWeight="light"
                                fontSize={12}
                                pl={0.5}
                                mt={0.5}
                              >
                                First column name, second column value or just a single column as
                                name and value
                              </MDTypography>
                            </MDBox>
                            <MDBox mt={2} display="flex" alignItems="center" ml={-1}>
                              <Checkbox
                                checked={formFieldEditable}
                                onChange={(e) => {
                                  setFormFieldEditable(e.target.checked);
                                }}
                                inputProps={{ "aria-label": "controlled" }}
                              />
                              <MDTypography
                                variant="button"
                                fontWeight="regular"
                                color="text"
                                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                              >
                                &nbsp;&nbsp;Allow users enter preferred option?
                              </MDTypography>
                            </MDBox>
                          </MDBox>
                        )}
                      </MDBox>
                    )}

                    {currentField && currentField.field_type === "calculated_value" && (
                      <MDBox mt={3}>
                        {/* <MDBox pl={1}>
                          <MDTypography variant="h6" fontSize={14} fontWeight="bold">
                            Mathematical Calculation
                          </MDTypography>
                        </MDBox> */}
                        <MDBox mt={4}>
                          <FormControl sx={{ minWidth: 120, width: "100%" }}>
                            <InputLabel>Calculation Type</InputLabel>
                            <Select
                              label="Calculation Type"
                              onChange={(e) => {
                                let tmpOpts = fieldMeta;
                                if (tmpOpts === null) {
                                  tmpOpts = {
                                    operator: e.target.value,
                                    fields: {
                                      first: {
                                        name: null,
                                        key: null,
                                      },
                                      second: {
                                        name: null,
                                        key: null,
                                      },
                                    },
                                  };
                                }
                                tmpOpts.operator = e.target.value;
                                setFieldMeta(tmpOpts);
                              }}
                              sx={{ padding: "12px", paddingLeft: "3px" }}
                            >
                              <MenuItem value="sum">Sum (Addition)</MenuItem>
                              <MenuItem value="difference">Difference (Substraction)</MenuItem>
                              <MenuItem value="product">Product (Multiplication)</MenuItem>
                              <MenuItem value="quotient">Quotient (Division)</MenuItem>
                              <MenuItem value="percentage">Percentage</MenuItem>
                            </Select>
                          </FormControl>
                        </MDBox>
                        <MDBox mt={3}>
                          <MDBox pl={1}>
                            <MDTypography variant="h6" fontSize={14} fontWeight="regular">
                              First Field
                            </MDTypography>
                          </MDBox>
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={6} lg={6}>
                              <MDInput
                                name="name"
                                margin="dense"
                                label="Display Name"
                                type="text"
                                fullWidth
                                variant="outlined"
                                onChange={(e) => {
                                  let tmpOpts = fieldMeta;
                                  if (tmpOpts === null) {
                                    tmpOpts = {
                                      operator: "",
                                      fields: {
                                        first: {
                                          name: null,
                                          key: null,
                                        },
                                        second: {
                                          name: null,
                                          key: null,
                                        },
                                      },
                                    };
                                  }
                                  tmpOpts.fields.first.name = e.target.value;
                                  setFieldMeta(tmpOpts);
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                              <MDInput
                                name="custom_key"
                                margin="dense"
                                label="Custom Key (Optional)"
                                type="text"
                                fullWidth
                                variant="outlined"
                                onChange={(e) => {
                                  let tmpOpts = fieldMeta;
                                  if (tmpOpts === null) {
                                    tmpOpts = {
                                      operator: "",
                                      fields: {
                                        first: {
                                          name: null,
                                          key: null,
                                        },
                                        second: {
                                          name: null,
                                          key: null,
                                        },
                                      },
                                    };
                                  }
                                  tmpOpts.fields.first.key = e.target.value;
                                  setFieldMeta(tmpOpts);
                                }}
                              />
                            </Grid>
                          </Grid>
                        </MDBox>
                        <MDBox mt={2}>
                          <MDBox pl={1}>
                            <MDTypography variant="h6" fontSize={14} fontWeight="regular">
                              Second Field
                            </MDTypography>
                          </MDBox>
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={6} lg={6}>
                              <MDInput
                                name="name"
                                margin="dense"
                                label="Display Name"
                                type="text"
                                fullWidth
                                variant="outlined"
                                onChange={(e) => {
                                  let tmpOpts = fieldMeta;
                                  if (tmpOpts === null) {
                                    tmpOpts = {
                                      operator: "",
                                      fields: {
                                        first: {
                                          name: null,
                                          key: null,
                                        },
                                        second: {
                                          name: null,
                                          key: null,
                                        },
                                      },
                                    };
                                  }
                                  tmpOpts.fields.second.name = e.target.value;
                                  setFieldMeta(tmpOpts);
                                }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                              <MDInput
                                name="custom_key"
                                margin="dense"
                                label="Custom Key (Optional)"
                                type="text"
                                fullWidth
                                variant="outlined"
                                onChange={(e) => {
                                  let tmpOpts = fieldMeta;
                                  if (tmpOpts === null) {
                                    tmpOpts = {
                                      operator: "",
                                      fields: {
                                        first: {
                                          name: null,
                                          key: null,
                                        },
                                        second: {
                                          name: null,
                                          key: null,
                                        },
                                      },
                                    };
                                  }
                                  tmpOpts.fields.second.key = e.target.value;
                                  setFieldMeta(tmpOpts);
                                }}
                              />
                            </Grid>
                          </Grid>
                        </MDBox>
                        <MDBox mt={3}>
                          <MDBox pl={1}>
                            <MDTypography variant="h6" fontSize={14} fontWeight="regular">
                              Calculated Field
                            </MDTypography>
                          </MDBox>
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={6} lg={6}>
                              <MDInput
                                name="name"
                                margin="dense"
                                label="Display Name"
                                type="text"
                                fullWidth
                                variant="outlined"
                                onChange={(e) => setFormFieldDisplayName(e.target.value)}
                              />
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                              <MDInput
                                name="custom_key"
                                margin="dense"
                                label="Custom Key (Optional)"
                                type="text"
                                fullWidth
                                variant="outlined"
                                onChange={(e) => setFormFieldKey(e.target.value)}
                              />
                            </Grid>
                          </Grid>
                        </MDBox>
                      </MDBox>
                    )}

                    {currentField && currentField.field_type === "formula_field" && (
                      <MDBox mt={3}>
                        <MDBox mt={2}>
                          <MDInput
                            name="formular"
                            margin="dense"
                            label="Mathematical Formula"
                            placeholder="Write your formula. Ex: (P1 + P2) - P3 / P4 * 100"
                            type="text"
                            multiline
                            minRows={1}
                            fullWidth
                            variant="outlined"
                            onChange={(e) => setFieldMeta({ formula: e.target.value })}
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                          <MDTypography ml={0.5} variant="h6" fontWeight="light" fontSize={14}>
                            Supported Operators:&nbsp;<b>+ - / * ( )</b>
                          </MDTypography>
                        </MDBox>
                        <MDBox mt={3}>
                          <MDBox p={1} display="flex" justifyContent="space-between">
                            <MDBox>
                              <MDTypography variant="h6" fontWeight="regular" fontSize={14}>
                                Formula Parameters
                              </MDTypography>
                            </MDBox>
                            <MDBox>
                              <Tooltip title="Add Parameter">
                                <MDButton
                                  variant="outlined"
                                  color="dark"
                                  size="small"
                                  iconOnly
                                  onClick={() => {
                                    addParam();
                                  }}
                                >
                                  <Icon>add</Icon>
                                </MDButton>
                              </Tooltip>
                              &nbsp;
                              <Tooltip title="Clear Parameters">
                                <MDButton
                                  variant="outlined"
                                  color="dark"
                                  size="small"
                                  iconOnly
                                  onClick={() => {
                                    setFormulaParams([]);
                                  }}
                                >
                                  <Icon>clear</Icon>
                                </MDButton>
                              </Tooltip>
                            </MDBox>
                          </MDBox>

                          <MDBox>
                            {formulaParams.map((param, pIdx) => (
                              <MDBox mb={1}>
                                <Grid container spacing={3}>
                                  <Grid item xs={3} md={3} lg={3}>
                                    <MDInput
                                      disabled
                                      name="param"
                                      margin="dense"
                                      label="Parameter"
                                      type="text"
                                      value={`P${pIdx + 1}`}
                                      fullWidth
                                      variant="outlined"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                    />
                                  </Grid>
                                  <Grid item xs={9} md={9} lg={9}>
                                    <MDBox mt={1}>
                                      <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                        <InputLabel>Form Field</InputLabel>
                                        <Select
                                          label="Form Field"
                                          onChange={(e) => {
                                            const temp = formulaParams;
                                            param = {
                                              param: `P${pIdx + 1}`,
                                              field: e.target.value,
                                            };
                                            temp[pIdx] = param;
                                            setFormulaParams(temp);
                                            console.log(formulaParams);
                                          }}
                                          sx={{ padding: "12px", paddingLeft: "3px" }}
                                          // defaultValue={param.field}
                                        >
                                          {
                                            // --> Notice below changes
                                            dataFormFields.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                              dataFormFields.map((record) => (
                                                <MenuItem value={`${record.reference}`}>
                                                  {record.display_name}
                                                </MenuItem>
                                              ))
                                          }
                                        </Select>
                                      </FormControl>
                                    </MDBox>
                                  </Grid>
                                </Grid>
                              </MDBox>
                            ))}
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    )}
                  </MDBox>
                ) : (
                  <MDBox>
                    <MDBox>
                      <MDBox mt={4}>
                        <MDInput
                          name="name"
                          margin="dense"
                          label="Display Name"
                          type="text"
                          fullWidth
                          variant="outlined"
                          onChange={(e) => setFormFieldDisplayName(e.target.value)}
                        />
                      </MDBox>
                      <MDBox mt={2}>
                        <MDInput
                          name="custom_key"
                          margin="dense"
                          label="Custom Key (Optional)"
                          type="text"
                          fullWidth
                          variant="outlined"
                          onChange={(e) => setFormFieldKey(e.target.value)}
                        />
                      </MDBox>
                    </MDBox>
                    <MDBox mt={5}>
                      <FormControl sx={{ minWidth: 120, width: "100%" }}>
                        <InputLabel>Related Parent Field</InputLabel>
                        <Select
                          label="Related Parent Field"
                          onChange={(e) => {
                            setRelatedParentField(e.target.value);
                          }}
                          sx={{ padding: "12px", paddingLeft: "3px" }}
                          value={relatedParentField}
                        >
                          {
                            // --> Notice below changes
                            dataFormFields.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                              dataFormFields.map((record) => (
                                <MenuItem value={`${record.reference}`}>
                                  {record.display_name}
                                </MenuItem>
                              ))
                          }
                        </Select>
                      </FormControl>
                    </MDBox>
                    <MDBox mt={3} mb={3}>
                      <MDBox p={1} display="flex" justifyContent="space-between">
                        <MDBox>
                          <MDTypography variant="h6">Related Options</MDTypography>
                        </MDBox>
                        <MDBox>
                          <MDButton
                            variant="outlined"
                            color="dark"
                            size="small"
                            iconOnly
                            onClick={() => {
                              setSelectedRelatedOptionIndex(null);
                              setRelatedParentOption(null);
                              setRelatedChildOptions(null);
                              setOpenAddRelatedOptionsDialog(true);
                            }}
                          >
                            <Icon>add</Icon>
                          </MDButton>
                        </MDBox>
                      </MDBox>
                      <MDBox>
                        <Table>
                          <TableBody>
                            <TableRow>
                              <TableCell>
                                <MDTypography variant="h6" fontSize={14} fontWeight="regular">
                                  Parent Value
                                </MDTypography>
                              </TableCell>
                              <TableCell>
                                <MDTypography variant="h6" fontSize={14} fontWeight="regular">
                                  Related Options
                                </MDTypography>
                              </TableCell>
                            </TableRow>
                            {buildRelatedOptionsTable()}
                          </TableBody>
                        </Table>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                )}
              </MDBox>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setFormFieldType(null);
              setValidationParams(null);
              setFormFieldOptions(null);
              setRelatedParentField(null);
              setOpenAddFieldDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              if (formFieldType === null) {
                setSeverity("error");
                setErrMsg("Field type is required.");
                setOpen(true);
                return;
              }
              if (formFieldDisplayName === null || formFieldDisplayName === "") {
                setSeverity("error");
                setErrMsg("Field display name is required.");
                setOpen(true);
                return;
              }

              if (isRelatedFields) {
                if (relatedParentField === null) {
                  setSeverity("error");
                  setErrMsg("Related parent field is required.");
                  setOpen(true);
                  return;
                }
              }
              addField();
            }}
          >
            Add
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openEditFieldDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <MDBox>Edit Field</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            {!isRelatedFields ? (
              <MDBox>
                {selectedField && (
                  <MDBox mt={1}>
                    <FormControl sx={{ minWidth: 120, width: "100%" }}>
                      <InputLabel>Field Type</InputLabel>
                      <Select
                        label="Field Type"
                        onChange={(e) => {
                          setFormFieldValidationParams(null);
                          // setFormFieldOptions([]);
                          setFormFieldType(e.target.value);
                        }}
                        sx={{ padding: "12px", paddingLeft: "3px" }}
                        defaultValue={selectedField.data_field.reference}
                      >
                        {
                          // --> Notice below changes
                          dataFields.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                            dataFields.map((record) => (
                              <MenuItem value={`${record.reference}`}>{record.name}</MenuItem>
                            ))
                        }
                      </Select>
                    </FormControl>
                  </MDBox>
                )}
                <MDBox mt={3}>
                  <MDInput
                    value={formFieldDisplayName}
                    name="name"
                    margin="dense"
                    label="Display Name"
                    type="text"
                    fullWidth
                    variant="outlined"
                    onChange={(e) => setFormFieldDisplayName(e.target.value)}
                  />
                </MDBox>

                <MDBox mt={2}>
                  <MDInput
                    name="custom_key"
                    margin="dense"
                    label="Custom Key (Optional)"
                    type="text"
                    fullWidth
                    variant="outlined"
                    value={formFieldKey}
                    onChange={(e) => setFormFieldKey(e.target.value)}
                  />
                </MDBox>
                <MDBox mt={2} display="flex" alignItems="center" ml={-1}>
                  <Checkbox
                    checked={formFieldOptional}
                    onChange={(e) => {
                      setFormFieldOptional(e.target.checked);
                    }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                  >
                    &nbsp;&nbsp;Make optional?
                  </MDTypography>
                </MDBox>
                {validationParams && (
                  <MDBox mt={2}>
                    <MDBox p={1}>
                      <MDTypography variant="h6" fontWeight="medium">
                        Validation Options
                      </MDTypography>
                    </MDBox>
                    {
                      // --> Notice below changes
                      validationParams.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                        validationParams.map((record) => {
                          let theValue = null;
                          // console.log(selectedFormFieldParamsOptions);
                          if (selectedFormFieldParamsOptions) {
                            if (record.key in selectedFormFieldParamsOptions) {
                              theValue = selectedFormFieldParamsOptions[record.key];
                            }
                          }

                          if (record.options) {
                            return (
                              <MDBox mt={3} mb={2}>
                                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                  <InputLabel>{record.name}</InputLabel>
                                  <Select
                                    label={record.name}
                                    onChange={(e) => {
                                      let params = formFieldValidationParams;
                                      if (params === null) {
                                        params = {};
                                      }
                                      params[record.key] = e.target.value;
                                      setFormFieldValidationParams(params);
                                    }}
                                    sx={{ padding: "12px", paddingLeft: "3px" }}
                                    defaultValue={theValue}
                                  >
                                    {
                                      // --> Notice below changes
                                      record.options.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                        record.options.map((opt) => (
                                          <MenuItem value={`${opt.value}`}>{opt.name}</MenuItem>
                                        ))
                                    }
                                  </Select>
                                </FormControl>
                              </MDBox>
                            );
                          }

                          return (
                            <MDBox mb={2}>
                              <MDInput
                                defaultValue={theValue}
                                margin="dense"
                                label={record.name}
                                type="text"
                                fullWidth
                                variant="outlined"
                                onChange={(e) => {
                                  if (e.target.value.length <= 0) {
                                    return;
                                  }

                                  let params = formFieldValidationParams;
                                  if (params === null) {
                                    params = {};
                                  }
                                  params[record.key] = e.target.value;
                                  setFormFieldValidationParams(params);
                                }}
                              />
                            </MDBox>
                          );
                        })
                    }
                  </MDBox>
                )}
                {showFieldOptions && (
                  <MDBox mt={2}>
                    <MDInput
                      value={selectedFormFieldOptions}
                      multiline
                      minRows={3}
                      name="form_options"
                      margin="dense"
                      label="Field Options"
                      placeholder="Comma separated name:value pairs."
                      type="text"
                      fullWidth
                      variant="outlined"
                      onChange={(e) => setSelectedFormFieldOptions(e.target.value)}
                    />
                    <MDBox pl={1}>
                      <small>Ex: Male:M, Female:F, Mercedes:benz, Vehicle Type:SUV</small>
                    </MDBox>
                    <MDBox mt={2}>
                      <MDTypography variant="h6" fontWeight="light" fontSize={13} pl={0.5}>
                        Upload CSV file
                      </MDTypography>
                      <TextField
                        type="file"
                        size="small"
                        placeholder="Upload csv options."
                        onChange={async (e) => {
                          const file = e.target.files[0];
                          try {
                            const string = await readOptionsCSV(file);
                            setSelectedFormFieldOptions(string);
                          } catch (error) {
                            console.error(error);
                          }
                        }}
                        startAdornment={
                          <InputAdornment position="start">
                            <Icon color="info">file</Icon>
                          </InputAdornment>
                        }
                        fullWidth
                      />
                      <MDTypography variant="h6" fontWeight="light" fontSize={12} pl={0.5} mt={0.5}>
                        First column name, second column value or just a single column as name and
                        value
                      </MDTypography>
                    </MDBox>

                    <MDBox mt={2} display="flex" alignItems="center" ml={-1}>
                      <Checkbox
                        checked={formFieldEditable}
                        onChange={(e) => {
                          setFormFieldEditable(e.target.checked);
                        }}
                        inputProps={{ "aria-label": "controlled" }}
                      />
                      <MDTypography
                        variant="button"
                        fontWeight="regular"
                        color="text"
                        sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                      >
                        &nbsp;&nbsp;Allow users enter preferred option?
                      </MDTypography>
                    </MDBox>
                  </MDBox>
                )}

                {isFormula && (
                  <MDBox mt={3}>
                    <MDBox mt={2}>
                      <MDInput
                        name="formular"
                        margin="dense"
                        label="Mathematical Formula"
                        placeholder="Write your formula. Ex: (P1 + P2) - P3 / P4 * 100"
                        type="text"
                        multiline
                        minRows={1}
                        fullWidth
                        variant="outlined"
                        onChange={(e) => setFormula(e.target.value)}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        defaultValue={formula}
                      />
                      <MDTypography ml={0.5} variant="h6" fontWeight="light" fontSize={14}>
                        Supported Operators:&nbsp;<b>+ - / * ( )</b>
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={3}>
                      <MDBox p={1} display="flex" justifyContent="space-between">
                        <MDBox>
                          <MDTypography variant="h6" fontWeight="regular" fontSize={14}>
                            Formula Parameters
                          </MDTypography>
                        </MDBox>
                        <MDBox>
                          <Tooltip title="Add Parameter">
                            <MDButton
                              variant="outlined"
                              color="dark"
                              size="small"
                              iconOnly
                              onClick={() => {
                                addParam();
                              }}
                            >
                              <Icon>add</Icon>
                            </MDButton>
                          </Tooltip>
                          &nbsp;
                          <Tooltip title="Clear Parameters">
                            <MDButton
                              variant="outlined"
                              color="dark"
                              size="small"
                              iconOnly
                              onClick={() => {
                                setFormulaParams([]);
                              }}
                            >
                              <Icon>clear</Icon>
                            </MDButton>
                          </Tooltip>
                        </MDBox>
                      </MDBox>

                      <MDBox>
                        {formulaParams.map((param, pIdx) => (
                          <MDBox mb={1}>
                            <Grid container spacing={3}>
                              <Grid item xs={3} md={3} lg={3}>
                                <MDInput
                                  disabled
                                  name="param"
                                  margin="dense"
                                  label="Parameter"
                                  type="text"
                                  value={`P${pIdx + 1}`}
                                  fullWidth
                                  variant="outlined"
                                  InputLabelProps={{
                                    shrink: true,
                                  }}
                                />
                              </Grid>
                              <Grid item xs={9} md={9} lg={9}>
                                <MDBox mt={1}>
                                  <FormControl sx={{ minWidth: 120, width: "100%" }}>
                                    <InputLabel>Form Field</InputLabel>
                                    <Select
                                      label="Form Field"
                                      onChange={(e) => {
                                        const temp = formulaParams;
                                        param = {
                                          param: `P${pIdx + 1}`,
                                          field: e.target.value,
                                        };
                                        temp[pIdx] = param;
                                        setFormulaParams(temp);
                                        console.log(formulaParams);
                                      }}
                                      sx={{ padding: "12px", paddingLeft: "3px" }}
                                      defaultValue={formulaParams[pIdx].field}
                                    >
                                      {
                                        // --> Notice below changes
                                        dataFormFields.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                          dataFormFields.map((record) => (
                                            <MenuItem value={`${record.reference}`}>
                                              {record.display_name}
                                            </MenuItem>
                                          ))
                                      }
                                    </Select>
                                  </FormControl>
                                </MDBox>
                              </Grid>
                            </Grid>
                          </MDBox>
                        ))}
                      </MDBox>
                    </MDBox>
                  </MDBox>
                )}
              </MDBox>
            ) : (
              <MDBox>
                <MDBox mt={3}>
                  <MDBox>
                    <MDBox>
                      <MDBox>
                        <MDInput
                          value={formFieldDisplayName}
                          name="name"
                          margin="dense"
                          label="Display Name"
                          type="text"
                          fullWidth
                          variant="outlined"
                          onChange={(e) => setFormFieldDisplayName(e.target.value)}
                        />
                      </MDBox>
                    </MDBox>
                    <MDBox mt={2}>
                      <MDInput
                        name="custom_key"
                        margin="dense"
                        label="Custom Key (Optional)"
                        type="text"
                        fullWidth
                        variant="outlined"
                        value={formFieldKey}
                        onChange={(e) => setFormFieldKey(e.target.value)}
                      />
                    </MDBox>
                  </MDBox>
                </MDBox>
                <MDBox mt={5}>
                  <FormControl sx={{ minWidth: 120, width: "100%" }}>
                    <InputLabel>Related Parent Field</InputLabel>
                    <Select
                      label="Related Parent Field"
                      onChange={(e) => {
                        setRelatedParentField(e.target.value);
                      }}
                      sx={{ padding: "12px", paddingLeft: "3px" }}
                      value={relatedParentField}
                    >
                      {
                        // --> Notice below changes
                        dataFormFields.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                          dataFormFields.map((record) => (
                            <MenuItem value={`${record.reference}`}>{record.display_name}</MenuItem>
                          ))
                      }
                    </Select>
                  </FormControl>
                </MDBox>
                <MDBox mt={3} mb={3}>
                  <MDBox p={1} display="flex" justifyContent="space-between">
                    <MDBox>
                      <MDTypography variant="h6">Related Options</MDTypography>
                    </MDBox>
                    <MDBox>
                      <MDButton
                        variant="outlined"
                        color="dark"
                        size="small"
                        iconOnly
                        onClick={() => {
                          setSelectedRelatedOptionIndex(null);
                          setRelatedParentOption(null);
                          setRelatedChildOptions(null);
                          setOpenAddRelatedOptionsDialog(true);
                        }}
                      >
                        <Icon>add</Icon>
                      </MDButton>
                    </MDBox>
                  </MDBox>
                  <MDBox>
                    <Table>
                      <TableBody>
                        <TableRow>
                          <TableCell>
                            <MDTypography variant="h6" fontSize={14} fontWeight="regular">
                              Parent Value
                            </MDTypography>
                          </TableCell>
                          <TableCell>
                            <MDTypography variant="h6" fontSize={14} fontWeight="regular">
                              Related Options
                            </MDTypography>
                          </TableCell>
                        </TableRow>
                        {buildRelatedOptionsTable()}
                      </TableBody>
                    </Table>
                  </MDBox>
                </MDBox>
              </MDBox>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenEditFieldDialog(false);
              setValidationParams(null);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              if (formFieldDisplayName === null || formFieldDisplayName === "") {
                setSeverity("error");
                setErrMsg("Field display name is required.");
                setOpen(true);
                return;
              }

              if (isRelatedFields) {
                if (relatedParentField === null) {
                  setSeverity("error");
                  setErrMsg("Related parent field is required.");
                  setOpen(true);
                  return;
                }
              }
              editField();
            }}
          >
            Save Changes
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openAddRelatedOptionsDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Related Options</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3}>
            <MDBox>
              <MDInput
                name="custom_key"
                margin="dense"
                label="Parent Value"
                type="text"
                fullWidth
                placeholder="Ex. Country name, Category name"
                variant="outlined"
                value={relatedParentOption}
                onChange={(e) => setRelatedParentOption(e.target.value)}
              />
              <Alert severity="info">
                <MDTypography variant="h6" fontWeight="regular" fontSize={13}>
                  Enter the parent&apos;s value exactly as it is saved. Pay attention to spaces and
                  case sensitivity.
                </MDTypography>
              </Alert>
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                value={relatedChildOptions}
                multiline
                minRows={3}
                name="form_options"
                margin="dense"
                label="Related Options"
                placeholder="Ex. List of country's states, list of products of a category"
                type="text"
                fullWidth
                variant="outlined"
                onChange={(e) => setRelatedChildOptions(e.target.value)}
              />
              <Alert severity="info">
                <MDTypography variant="h6" fontWeight="regular" fontSize={13}>
                  Comma separated NAME:VALUE pairs OR single values.
                  <br />
                  Examples: Nigeria:NG, Ghana:GH or NG, GH
                </MDTypography>
              </Alert>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setSelectedRelatedOptionIndex(null);
              setRelatedParentOption(null);
              setRelatedChildOptions(null);
              setOpenAddRelatedOptionsDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="info"
            variant="outlined"
            onClick={() => {
              if (relatedParentOption === null || relatedParentOption.length === 0) {
                return;
              }

              if (relatedChildOptions === null || relatedChildOptions.length === 0) {
                return;
              }

              const tmp = relatedOptions;
              if (selectedRelatedOptionIndex !== null) {
                delete tmp[selectedRelatedOptionIndex];
                tmp[relatedParentOption] = relatedChildOptions;
              } else {
                tmp[relatedParentOption] = relatedChildOptions;
              }

              // console.log(tmp);
              setRelatedOptions(tmp);
              setOpenAddRelatedOptionsDialog(false);
            }}
          >
            Set
          </MDButton>
        </DialogActions>
      </Dialog>
      {dataForm !== null && (
        <MDBox pt={1.5} pb={3} mb={3}>
          <MDBox display="flex" justifyContent="space-between">
            <MDBox>
              <Button
                color="dark"
                startIcon={<Icon>west</Icon>}
                onClick={() => {
                  navigate(`/data-forms`);
                }}
              >
                Back
              </Button>
            </MDBox>
            <MDBox>
              <Button
                color="dark"
                startIcon={<Icon>attribution</Icon>}
                onClick={() => {
                  setOpenLinkBucketDialog(true);
                }}
              >
                Lead Connector
              </Button>
            </MDBox>
          </MDBox>
          <MDBox mt={0}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={6}>
                <MDBox>
                  <Card sx={{ width: "100%", marginTop: "10px" }}>
                    <MDBox p={3}>
                      <MDTypography variant="h6" fontWeight="medium">
                        Data Form
                      </MDTypography>
                      <MDBox mt={2}>
                        <MDInput
                          value={dataFormName}
                          name="name"
                          margin="dense"
                          label="Name"
                          type="text"
                          fullWidth
                          variant="outlined"
                          onChange={(e) => setDataFormName(e.target.value)}
                        />
                      </MDBox>
                      <MDBox mt={2}>
                        <MDInput
                          value={formSuccessMessage}
                          placeholder="Enter a message to display upon successful submission."
                          multiline
                          minRows={3}
                          name="name"
                          margin="dense"
                          label="Submission Success Message"
                          type="text"
                          fullWidth
                          variant="outlined"
                          onChange={(e) => setFormSuccessMessage(e.target.value)}
                        />
                      </MDBox>
                      <MDBox mt={2} align="right">
                        <MDButton
                          size="small"
                          color="dark"
                          variant="outlined"
                          onClick={() => {
                            editFormName();
                          }}
                        >
                          Save Changes
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
                <MDBox mt={3}>
                  <Card sx={{ width: "100%", marginTop: "10px" }}>
                    <MDBox p={3}>
                      <MDBox display="flex" justifyContent="space-between" alignItems="center">
                        <MDTypography variant="h6" fontWeight="medium">
                          Form Sections
                        </MDTypography>
                        <Tooltip title="Add Section">
                          <MDButton
                            variant="outlined"
                            color="dark"
                            iconOnly
                            size="small"
                            onClick={() => {
                              setOpenAddSectionDialog(true);
                              setDataFormSectionName(null);
                              setDataFormSectionDescription(null);
                            }}
                          >
                            <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                          </MDButton>
                        </Tooltip>
                      </MDBox>
                      <MDBox>
                        <Divider />
                      </MDBox>
                      {dataFormSections.length > 0 ? (
                        <>
                          <MDBox mt={3} id="sortableSections">
                            <ReactSortable list={dataFormSections} setList={setDataFormSections}>
                              {
                                // --> Notice below changes
                                dataFormSections.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                  dataFormSections.map((record, index) => (
                                    <MDBox mb={3}>
                                      <Grid container spacing={0}>
                                        <Grid item xs={1} md={1} lg={1}>
                                          <MDBox display="flex" alignItems="center" pt={1}>
                                            {/* <Icon fontSize="medium">swap_vert</Icon> */}
                                            <Icon fontSize="medium">drag_indicator</Icon>
                                          </MDBox>
                                        </Grid>
                                        <Grid item xs={11} md={11} lg={11}>
                                          <MDBox mb={2}>
                                            <MDBox
                                              display="flex"
                                              justifyContent="space-between"
                                              alignItems="right"
                                            >
                                              <MDBox df_ref={`${index}`}>
                                                <MDTypography variant="h6" fontWeight="regular">
                                                  {record.title}
                                                </MDTypography>
                                              </MDBox>
                                              <MDBox align="right">
                                                <Tooltip title="Edit Fields">
                                                  <MDButton
                                                    size="small"
                                                    variant={sectionHighlight(record)}
                                                    iconOnly
                                                    circular
                                                    color="dark"
                                                    onClick={() => {
                                                      setSelectedDataFormSection(record);
                                                      // setSelectedDataFormSectionFields(record.fields);
                                                    }}
                                                  >
                                                    <Icon>dynamic_form</Icon>
                                                  </MDButton>
                                                </Tooltip>
                                                &nbsp;|&nbsp;
                                                <Tooltip title="Edit Section">
                                                  <MDButton
                                                    size="small"
                                                    variant="outlined"
                                                    iconOnly
                                                    circular
                                                    color="warning"
                                                    onClick={() => {
                                                      setDataFormSectionName(record.title);
                                                      setDataFormSectionDescription(
                                                        record.description
                                                      );
                                                      setSelectedSection(record);
                                                      setOpenEditSectionDialog(true);
                                                    }}
                                                  >
                                                    <Icon>edit</Icon>
                                                  </MDButton>
                                                </Tooltip>
                                                &nbsp;
                                                <Tooltip title="Delete Section">
                                                  <MDButton
                                                    size="small"
                                                    variant="outlined"
                                                    iconOnly
                                                    circular
                                                    color="error"
                                                    onClick={() => {
                                                      if (
                                                        window.confirm(
                                                          `Delete section? All previously captured data will be lost. This action is not reversible.`
                                                        ) === true
                                                      ) {
                                                        removeSection(record.reference);
                                                      }
                                                    }}
                                                  >
                                                    <Icon>close</Icon>
                                                  </MDButton>
                                                </Tooltip>
                                              </MDBox>
                                            </MDBox>
                                            <MDBox>
                                              <MDTypography variant="h6" fontWeight="light">
                                                {record.description}
                                              </MDTypography>
                                            </MDBox>
                                          </MDBox>
                                        </Grid>
                                      </Grid>
                                    </MDBox>
                                  ))
                              }
                            </ReactSortable>
                          </MDBox>

                          <MDBox mt={1}>
                            <Divider />
                            <MDTypography variant="subtitle2" fontSize={14} align="center">
                              Drag sections to re-order your data form accordingly.
                            </MDTypography>
                          </MDBox>
                          <MDBox mt={3} align="right">
                            <MDButton
                              size="small"
                              color="dark"
                              variant="outlined"
                              onClick={() => {
                                reOrderSections();
                              }}
                            >
                              Save Changes
                            </MDButton>
                          </MDBox>
                        </>
                      ) : (
                        <MDBox mt={1} align="center">
                          <MDBox>
                            <MDTypography variant="h6" fontSize={48}>
                              <Icon>category</Icon>
                            </MDTypography>
                            <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                              Organise your form in sections. Give your users a consistent
                              experience.
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                      )}
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <Card sx={{ width: "100%", marginTop: "10px" }}>
                  <MDBox p={3} display="flex" justifyContent="space-between">
                    <MDTypography variant="h6" fontWeight="medium">
                      Section Fields
                    </MDTypography>
                    <MDBox>
                      <Icon color="dark">dynamic_form</Icon>
                    </MDBox>
                  </MDBox>
                </Card>
                <MDBox mt={3}>
                  {selectedDataFormSection != null ? (
                    <MDBox mb={3}>
                      <Card sx={{ width: "100%", marginTop: "10px" }}>
                        <MDBox p={2}>
                          <MDBox
                            mb={2}
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <MDBox>
                              <MDTypography variant="h6" fontWeight="bold">
                                {selectedDataFormSection.title}
                              </MDTypography>
                            </MDBox>
                            <Tooltip title="Add Field">
                              <MDButton
                                variant="outlined"
                                color="dark"
                                size="small"
                                iconOnly
                                onClick={() => {
                                  setSelectedSection(selectedDataFormSection);
                                  setFormFieldType(null);
                                  setFormFieldDisplayName(null);
                                  setFormFieldKey(null);
                                  setFormFieldOptions([]);
                                  setFormFieldValidationParams(null);
                                  setValidationParams(null);
                                  setRelatedOptions({});
                                  setIsRelatedFields(false);
                                  setOpenAddFieldDialog(true);
                                  setFormFieldEditable(false);
                                  setFormFieldOptional(false);
                                }}
                              >
                                <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                              </MDButton>
                            </Tooltip>
                          </MDBox>
                          <MDBox>
                            <ReactSortable
                              list={selectedDataFormSectionFields}
                              setList={setSelectedDataFormSectionFields}
                            >
                              {
                                // --> Notice below changes
                                selectedDataFormSectionFields.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                                  selectedDataFormSectionFields.map((field, idx) => (
                                    <MDBox df_ref={`${idx}`} mb={2}>
                                      <ListItem>
                                        <ListItemIcon>
                                          <MDBox variant="button">
                                            <Icon>drag_indicator</Icon>
                                          </MDBox>
                                        </ListItemIcon>
                                        <ListItemText
                                          primary={
                                            <MDTypography variant="caption" fontWeight="light">
                                              {field.field_name}{" "}
                                              {field.is_optional ? "(Optional)" : ""}
                                            </MDTypography>
                                          }
                                          secondary={
                                            <MDTypography variant="h6" fontWeight="regular">
                                              {field.display_name}
                                            </MDTypography>
                                          }
                                        />
                                        <MDBox>
                                          {field.type !== "calculated_value" && (
                                            <span>
                                              <Tooltip title="Edit Field">
                                                <MDButton
                                                  size="small"
                                                  variant="outlined"
                                                  iconOnly
                                                  circular
                                                  color="warning"
                                                  onClick={() => {
                                                    // console.log(field);
                                                    setSelectedField(field);
                                                    setFormFieldType(field.data_field.reference);
                                                    setFormFieldDisplayName(field.display_name);
                                                    setFormFieldKey(field.custom_key);
                                                    setFormFieldEditable(field.editable);
                                                    setFormFieldOptional(field.is_optional);
                                                    if (field.data_field.related_field) {
                                                      setRelatedParentField(field.parent.reference);

                                                      const opts = {};
                                                      for (const [key, value] of Object.entries(
                                                        field.options
                                                      )) {
                                                        console.log(`${key}: ${value}`);
                                                        let vOpts = "";
                                                        value.every((param) => {
                                                          vOpts += `${param.name}:${param.value},\n`;
                                                          return true;
                                                        });
                                                        opts[key] = vOpts;
                                                      }
                                                      setRelatedOptions(opts);

                                                      setIsRelatedFields(true);
                                                      setOpenEditFieldDialog(true);
                                                      return;
                                                    }

                                                    if (
                                                      field.data_field.field_type ===
                                                      "formula_field"
                                                    ) {
                                                      setIsFormula(true);
                                                      setFormula(field.options.formula);
                                                      setFormulaParams(field.options.parameters);
                                                      setOpenEditFieldDialog(true);
                                                      return;
                                                    }

                                                    setShowFieldOptions(false);
                                                    setValidationParams(null);
                                                    if (field.data_field.options_reqd) {
                                                      setShowFieldOptions(true);
                                                      let opts = "";
                                                      field.options.every((param) => {
                                                        opts += `${param.name}:${param.value},\n`;
                                                        return true;
                                                      });
                                                      // console.log(opts);
                                                      setSelectedFormFieldOptions(opts);
                                                      setFormFieldOptions(opts);
                                                      setValidationParams(null);
                                                      setOpenEditFieldDialog(true);
                                                      return;
                                                    }

                                                    if (
                                                      Object.keys(
                                                        field.data_field.pre_validation_params
                                                      ).length > 0
                                                    ) {
                                                      // console.log(field.data_field.pre_validation_params);
                                                      setFormFieldValidationParams(
                                                        field.options ? field.options : {}
                                                      );
                                                      setValidationParams(
                                                        field.data_field.pre_validation_params
                                                      );
                                                      setSelectedFormFieldParamsOptions(
                                                        field.options
                                                      );
                                                    }

                                                    setOpenEditFieldDialog(true);
                                                  }}
                                                >
                                                  <Icon>edit</Icon>
                                                </MDButton>
                                              </Tooltip>
                                              &nbsp;
                                            </span>
                                          )}
                                          <Tooltip title="Delete Field">
                                            <MDButton
                                              size="small"
                                              variant="outlined"
                                              iconOnly
                                              circular
                                              color="error"
                                              onClick={() => {
                                                if (
                                                  window.confirm(
                                                    `Delete field? All previously collected data will be lost. This action is not reversible.`
                                                  ) === true
                                                ) {
                                                  removeField(field.reference);
                                                }
                                              }}
                                            >
                                              <Icon>close</Icon>
                                            </MDButton>
                                          </Tooltip>
                                        </MDBox>
                                      </ListItem>
                                    </MDBox>
                                  ))
                              }
                            </ReactSortable>
                          </MDBox>
                          <MDBox mt={3}>
                            <Divider />
                          </MDBox>
                          <MDBox mt={3} align="right">
                            <MDButton
                              size="small"
                              color="dark"
                              variant="outlined"
                              onClick={() => {
                                reOrderSectionFields();
                              }}
                            >
                              Save Changes
                            </MDButton>
                          </MDBox>
                        </MDBox>
                      </Card>
                    </MDBox>
                  ) : (
                    <MDBox>
                      <Card>
                        <MDBox p={3} align="center">
                          <MDTypography variant="subtitle2" fontSize={32}>
                            <Icon>dynamic_form</Icon>
                          </MDTypography>
                          <MDTypography variant="subtitle2">No form section selected.</MDTypography>
                        </MDBox>
                      </Card>
                    </MDBox>
                  )}
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>
          <MDBox mt={3}>
            <Card sx={{ width: "100%", marginTop: "10px" }}>
              <MDBox p={3} display="flex" justifyContent="space-between">
                <MDBox>
                  <MDTypography variant="h6" fontWeight="medium">
                    Validation Rules
                  </MDTypography>
                </MDBox>
                <MDBox>
                  <MDButton
                    variant="outlined"
                    color="dark"
                    iconOnly
                    size="small"
                    onClick={() => {
                      setSelectedRule(null);
                      setSelectedRuleFields({});
                      setOpenAddValidatorDialog(true);
                    }}
                  >
                    <Icon color="dark">add</Icon>
                  </MDButton>
                </MDBox>
              </MDBox>
              <MDBox>
                {formRules.length > 0 ? (
                  <MDBox mt={1} pb={3}>
                    <DataTable
                      table={{ columns: formRulesTableColumns, rows: formRules }}
                      isSorted
                      entriesPerPage={false}
                      showTotalEntries={false}
                      noEndBorder
                      canSearch={false}
                    />
                  </MDBox>
                ) : (
                  <MDBox mt={1} align="center">
                    <MDBox>
                      <MDTypography variant="h6" fontSize={48}>
                        <Icon>rules</Icon>
                      </MDTypography>
                      <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                        Add validation rules from a wide selection that suits your data needs.
                        Improve overall data integrity.
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={5} mb={3}>
                      <MDButton
                        variant="contained"
                        color="dark"
                        onClick={() => {
                          setSelectedRule(null);
                          setSelectedRuleFields({});
                          setOpenAddValidatorDialog(true);
                        }}
                        startIcon={<Icon>add</Icon>}
                      >
                        Add Validation Rule
                      </MDButton>
                    </MDBox>
                  </MDBox>
                )}
              </MDBox>
            </Card>
          </MDBox>
          <MDBox mt={3}>
            <Card sx={{ width: "100%", marginTop: "10px" }}>
              <MDBox p={3} display="flex" justifyContent="space-between">
                <MDBox>
                  <MDTypography variant="h6" fontWeight="medium">
                    Dynamic Flows
                  </MDTypography>
                </MDBox>
                <MDBox>
                  <MDButton
                    variant="outlined"
                    color="dark"
                    iconOnly
                    size="small"
                    onClick={() => {
                      setSelectedNavigationLogicField(null);
                      setSelectedNavigationLogicFieldControlValue(null);
                      setSelectedNavigationLogicFieldDisplayType(null);
                      setSelectedNavigationLogicFieldDependant(null);
                      setOpenNewNavigationLogicDialog(true);
                    }}
                  >
                    <Icon color="dark">add</Icon>
                  </MDButton>
                </MDBox>
              </MDBox>
              <MDBox>
                {navigationLogics.length > 0 ? (
                  <MDBox mt={1} pb={3}>
                    <DataTable
                      table={{ columns: navigationLogicTableColumns, rows: navigationLogics }}
                      isSorted
                      entriesPerPage={false}
                      showTotalEntries={false}
                      noEndBorder
                      canSearch={false}
                    />
                  </MDBox>
                ) : (
                  <MDBox mt={1} align="center">
                    <MDBox>
                      <MDTypography variant="h6" fontSize={48}>
                        <Icon>alt_route</Icon>
                      </MDTypography>
                      <MDTypography variant="h6" fontWeight="light" fontSize={16}>
                        Add dynamic workflows to your forms. Control captured data based on user
                        selections.
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={5} mb={3}>
                      <MDButton
                        variant="contained"
                        color="dark"
                        onClick={() => {
                          setSelectedNavigationLogicField(null);
                          setSelectedNavigationLogicFieldControlValue(null);
                          setSelectedNavigationLogicFieldDisplayType(null);
                          setSelectedNavigationLogicFieldDependant(null);
                          setOpenNewNavigationLogicDialog(true);
                        }}
                        startIcon={<Icon>add</Icon>}
                      >
                        Add Dynamic Flow
                      </MDButton>
                    </MDBox>
                  </MDBox>
                )}
              </MDBox>
            </Card>
          </MDBox>
        </MDBox>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default EditDataForm;
